import { ContentItem, ContentItems } from '../../../api';

export class FeaturedArticleMapper {
  map(contentItems: ContentItems) {
    const { total, items } = contentItems;
    return {
      total,
      items: items.map((item) => this.mapItem(item)),
    };
  }

  private mapItem(item: ContentItem) {
    const { content = {}, full_slug } = item;
    const {
      categories = [],
      externalUrl = null,
      _uid = null,
      component = null,
      _editable = null,
      previewImage,
      title = null,
      shortDescription = null,
    } = content;

    return {
      content: {
        title,
        shortDescription,
        categories: categories.map((category: any) => this.mapCategory(category)),
        externalUrl,
        previewImage: {
          filename: previewImage?.filename || null,
        },
        _uid,
        component,
        _editable,
      },
      full_slug,
    };
  }

  private mapCategory(category: any) {
    const { content = {} } = category;
    const { name = null } = content;

    return {
      content: { name },
    };
  }
}
